import type { ProgressReportStore } from '@stores/progress-report/interfaces'

import { getReport } from '@utils/stores/progress-report/getters/report'
import { isFullArray } from '@helpers/array'

const getAchievements = (state: ProgressReportStore): string[] => getReport(state)?.achievements || []

export const achievements = {
  getAchievements: (state: ProgressReportStore): string[] => getAchievements(state),
  hasAchievements: (state: ProgressReportStore): boolean => isFullArray(getAchievements(state)),
}
